import { createApi } from '@reduxjs/toolkit/query/react';
import apiBaseQuery from './axiosBaseQuery'
export const CLIMATE_SCENARIOS_API_REDUCER_KEY = 'climateScenarioApi';


export const climateScenarioApi = createApi({
    reducerPath: CLIMATE_SCENARIOS_API_REDUCER_KEY,
    baseQuery: apiBaseQuery,
    tagTypes: ['climateScenarios'],
    endpoints: (builder) => ({
        getAllClimateScenarios: builder.query({
            query: () => ({
                url: `admin/repository/climate-scenarios`
            }),
            providesTags: ['climateScenarios']
        }),
        getClimateScenarios: builder.query({
            query: (id) => ({
                url: `admin/repository/climate-scenarios/${id}`
            }),
            providesTags: ['climateScenarios']
        }),
        createClimateScenarios: builder.mutation({
            query: (body) => ({
                url: `admin/repository/climate-scenarios`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['climateScenarios']
        }),
        updateClimateScenarios: builder.mutation({
            query: ({ id, ...rest }) => ({
                url: `admin/repository/climate-scenarios/${id}`,
                method: 'PUT',
                body: rest,
            }),
            invalidatesTags: ['climateScenarios']
        }),
    })
});

export const {
    useGetAllClimateScenariosQuery,
    useGetClimateScenariosQuery,
    useCreateClimateScenariosMutation,
    useUpdateClimateScenariosMutation,
} = climateScenarioApi;